<template>
    <fragment>
        <template v-if="isNotFound">
            <PageNotFound />
        </template>
        <main v-else class="ws-page">
            <template v-if="!isLoading">
                <header class="ws-de-center__item-header no-x-padding">
                    <div class="ws-de-center__item-title" :style="{'border-left-color': deCenter.color }" >
                    <h2 class="is-size-3 has-text-primary has-text-weight-bold">
                        <span v-text="deCenter.name && deCenter.name.translate && deCenter.name.translate.ru"></span>
                        <router-link class="ws-de-center__item-header-link"
                                    :to="`/demo-exams/?de_center_guid=${deCenter.guid}&day_cm1.from=${getCurrentYear}-01-01&day_cm1.till=${getCurrentYear}-12-31`">
                        <b-tooltip :label="$t('Перейти к списку экзаменов')"
                                    type="is-dark">
                            <ws-icon
                                    class="ws-button__icon is-position-left"
                                    name="list"
                                    color="#1c3b8d"
                                    width="24"
                                    height="24"
                            />
                        </b-tooltip>
                        </router-link>
                        <button class="ws-button button is-text ws-de-center__item-header-link" @click="copyInfoToClipboard">
                        <b-tooltip :label="$t('Скопировать данные о ЦПДЭ в буфер обмена')"
                                    type="is-dark">
                            <ws-icon
                                class="ws-button__icon"
                                name="copy"
                                color="#1c3b8d"
                                width="16"
                                height="24"
                            />
                        </b-tooltip>
                        </button>
                    </h2>
                    <address>
                        <span v-if="deCenter.address && deCenter.address.locality && deCenter.address.locality.title && deCenter.address.locality.title.display">{{ deCenter.address.locality.title.display }} &nbsp;</span>
                        <span v-if="deCenter.address">{{ deCenter.address.address.translate.ru }}</span>
                    </address>
                    </div>
                    <div class="ws-de-center__item-meta">
                    <ws-icon
                        class="ws-button__icon is-position-left"
                        name="geo-marker"
                        color="#6D9AE8"
                        width="12"
                        height="16"
                    />
                    <span class="ws-button__text has-text-info" v-if="deCenter.address" v-text="deCenter.address.region.title.display"></span>
                    </div>
                </header>
                <div>
                    <h3 class="has-text-primary is-size-2">Сведения о связанной организации</h3>
                    <div v-if="institution.title" class="has-text-primary sub-title is-size-3">
                        <span>{{ institution.title && institution.title.translate && institution.title.translate.ru }}</span>
                        <router-link class="has-text-primary" :to="`/orgs/${institution.guid}/groups`">
                            <span class="has-text-primary ml-1">(открыть)</span>
                        </router-link>
                    </div>
                    <div class="has-text-primary is-size-3">
                        <span>Адрес: </span>
                        <span>{{ instAddress }}</span>
                    </div>
                    <div class="has-text-primary is-size-3">
                        <span>ИНН: </span>
                        <span class="mr-2">{{institution.inn}}</span>
                        <span>КПП: </span>
                        <span>{{institution.kpp}}</span>
                    </div>
                    <h3 class="has-text-primary is-size-2 attestat">Аттестаты</h3>
                </div>
                <ws-de-center-accred-comps-table class="no-padding" :data="deCenter.accred_comps" :de-center-guid="deCenter.guid" />
            </template>
            <template v-else>
                <ws-list-view-skeleton-item
                    :height="'50px'"
                    :boxCount="1"
                    :boxHeights="['18px']"
                    />
                    <ws-list-view-skeleton-item
                    :height="'100px'"
                    :boxCount="1"
                    :boxHeights="['18px']"
                    />
                    <ws-list-view-skeleton-item
                    :height="'25px'"
                    :boxCount="1"
                    :boxHeights="['18px']"
                />
            </template>
        </main>
    </fragment>
</template>

<script>
import { mapActions } from 'vuex'
import clipboardMixin from '@/mixins/clipboard.mixin'
import { constants } from '@/services/constants.service'
import PageNotFound from '@/views/PageNotFound'
import { Fragment } from 'vue-fragment'

export default {
  name: 'DeCenterDetail',
  components: { PageNotFound, Fragment },
  mixins: [clipboardMixin],
  data () {
    return {
      deCenter: {},
      institution: {},
      isLoading: false,
      isNotFound: false
    }
  },
  computed: {
    getDeCenterGuid () {
      return this.$route.params.id
    },
    getCurrentYear () {
      return new Date().getFullYear()
    },
    instAddress () {
      const address = this.institution.address && this.institution.address.address && this.institution.address.address.translate && this.institution.address.address.translate.ru
      const locality = this.institution.address && this.institution.address.locality && this.institution.address.locality.title && this.institution.address.locality.title.translate && this.institution.address.locality.title.translate.ru
      const region = this.institution.address && this.institution.address.region && this.institution.address.region.title && this.institution.address.region.title.translate && this.institution.address.region.title.translate.ru
      return `${region ? region + ',' : ''} ${locality ? locality + ',' : ''} ${address || ''}`
    }
  },
  methods: {
    ...mapActions('de-centers', ['get']),
    ...mapActions('public/refbook/education/institution', { getInstitution: 'get' }),
    copyInfoToClipboard () {
      const link = `Наименование: ${this.deCenter.name.translate.ru} \nРегион: ${this.deCenter.address.region.title.display}`
      this.copyToClipboard(link)
      this.$buefy.toast.open({
        message: `Информация о ЦПДЭ успешно скопирована`,
        type: 'is-success'
      })
    }
  },
  async created () {
    try {
      this.isLoading = true
      this.deCenter = await this.get([this.getDeCenterGuid])
      if (this.deCenter.parent.guid !== constants.NULL_GUID) {
        this.institution = await this.getInstitution([this.deCenter.parent.guid])
      }
    } catch (e) {
      if (e && e.code === 404) {
        this.isNotFound = true
      }
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.no-x-padding {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
}

.no-padding {
    padding: 0;
}

.ml-1 {
    margin-left: 5px;
}

.mr-2 {
    margin-right: 0.5rem;
}

.sub-title {
    margin-top: 5px;

    > a {
        text-decoration: underline;
    }
}

.attestat {
    margin: 20px 0 15px;
}
</style>
